import template from './index.jst';
import './index.styl';

import Preloader from '../../../../../core/utils/Preloader';
import { redirectTo } from '../../../../../core/utils';
import { CoreLeagueCreateView } from '../../../../../core/views';
import { User as UserModel } from '../../../models';

/**
 * @desc Comps Create View
 * This class using on league create page ('comps/create')
 */
class CompsCreateView extends CoreLeagueCreateView {
	get template() {
		return template;
	}

	get className() {
		return "comps-create-page shadow";
	}

	/**
	 * Set all UI for this view
	 * @returns object
	 */
	ui() {
		return {
			...super.ui(),
			submit_form:         '.js-submit-comp-form',
			league_form:         '.js-comp-form',
			league_name:         '.js-comp-name',
			display_league_name: '.js-display-comp-name',
			form_switch:         '.js-form-switch',
			advanced_option:     '.js-advanced-options',
			display_avatar:      '.js-display-img',
			league_avatar:       '.js-comp-avatar',
			privacy_settings:    '.js-privacy-settings',
			start_round:         '.js-start-round',
			coaches_box:         '.js-coaches-box',
			form_error:          '.js-form-error'
		};
	}

	/**
	 *
	 */
	createCompSuccess() {
		Preloader.hide();
		let comp_id = this.model.get( 'id' ),
			url     = `comps/${comp_id}/congratulation`;

		redirectTo( url );
	}

	/**
	 *
	 * @param element
	 */
	updateDisplayCompName( element ) {
		let new_name = $( element.currentTarget ).val();
		this.getUI( 'display_comp_name' ).text( new_name );
	}

	getDefaultLeagueName() {
		return UserModel.get( 'firstname' )+"'s" + ' Comp';
	}

	/**
	 *
	 * @returns {CompsCreateView}
	 */
	setFormElements() {
		let form_elements = {
			name:        this.getUI( 'league_name' ).val(),
			privacy:     this.getUI( 'privacy_settings' ).filter( ':checked' ).val(),
			start_round: this.getUI( 'start_round' ).val(),
			coaches_box: this.getUI( 'coaches_box' ).filter( ':checked' ).val()
		};

		this.model.set( form_elements );

		return this;
	}

	createLeagueSuccess() {
		Preloader.hide();
		let league_id = this.model.get( 'id' ),
			url       = `/comps/${league_id}/invites`;

		redirectTo( url );
	}

	/**
	 *
	 * @returns {CompsCreateView}
	 */
	updateModel() {
		this.rounds.setFinalRound();
		super.updateModel();

		return this;
	}

}

export default CompsCreateView;